import { useState } from 'react';
var LandingPageBG = function LandingPageBG(_ref) {
  var onLoaded = _ref.onLoaded;
  useState(function () {
    var img = new window.Image();
    img.onload = function () {
      var img = new window.Image();
      img.onload = function () {
        onLoaded();
      };
      img.src = '/public/images/landingpage-bg.jpg';
    };
    img.src = '/public/images/landingpage-bg-small.jpg';
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "landingpage__bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "landingpage__bg--small"
  }), /*#__PURE__*/React.createElement("div", {
    className: "landingpage__bg--large"
  }));
};
export default LandingPageBG;